"use client";

import { Leaf, Droplets, Recycle, Award, Wind } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComplianceStandards() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: itemsRef,
    isVisible: itemsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const credentials = [{
    icon: Leaf,
    label: "ISO CERTIFIED",
    description: "Rigorous quality management systems for every project."
  }, {
    icon: Droplets,
    label: "SAFETY PROTOCOLS",
    description: "Strict adherence to industrial health and safety standards."
  }, {
    icon: Recycle,
    label: "WASTE REDUCTION",
    description: "Optimized material usage to minimize environmental impact."
  }, {
    icon: Award,
    label: "INDUSTRY COMPLIANT",
    description: "Full alignment with national manufacturing regulations."
  }, {
    icon: Wind,
    label: "EMISSION CONTROL",
    description: "Advanced filtration systems for cleaner production cycles."
  }];
  return <section data-section-id="4418" id="compliance-standards" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 md:h-96 md:w-96 opacity-25 blur-2xl" style={{
      backgroundColor: "var(--chart-3)"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-[0.25em] uppercase mb-6" style={{
          color: "var(--chart-3)"
        }}>
            Operational Integrity
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground" style={{
          fontFamily: "var(--font-default)"
        }}>
            Excellence defined by compliance.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed font-default" style={{
          color: "var(--foreground)"
        }}>
            Every process, every protocol, and every standard — upheld with 
            unwavering commitment to quality and safety.
          </p>
        </div>

        {}
        <div ref={itemsRef} className="relative mt-20 md:mt-24">
          {}
          <div aria-hidden="true" className="hidden md:block absolute left-0 right-0 top-[60px] h-px" style={{
          backgroundColor: "var(--border)",
          opacity: 0.4
        }} />

          {}
          <div aria-hidden="true" className="md:hidden absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2" style={{
          backgroundColor: "var(--border)",
          opacity: 0.3
        }} />

          <div className="relative grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-6 md:gap-x-4">
            {credentials.map((item, i) => {
            const Icon = item.icon;
            return <div data-index={i} key={item.label} className={`relative flex flex-col items-center text-center px-2 transition-all duration-700 ease-out ${itemsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: `${i * 120}ms`
            }}>
                  {}
                  {i < credentials.length - 1 && <div aria-hidden="true" className="hidden md:block absolute right-0 top-8 bottom-8 w-px translate-x-2" style={{
                backgroundColor: "var(--border)",
                opacity: 0.6
              }} />}

                  {}
                  <div className="relative flex items-center justify-center w-20 h-20 md:w-[120px] md:h-[120px] rounded-lg bg-card">
                    <Icon strokeWidth={1.25} className="w-10 h-10 md:w-12 md:h-12" style={{
                  color: "var(--primary)"
                }} aria-hidden="true" />
                  </div>

                  <h3 className="mt-5 font-mono text-[11px] md:text-xs tracking-[0.2em] uppercase text-foreground font-default">
                    {item.label}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed max-w-[180px] font-default" style={{
                color: "var(--foreground)"
              }}>
                    {item.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}